<style scoped lang="sass">
@import '../../variables'

.request-name
  color: #000
.opportunity
  color: #222
</style>
<template lang='pug'>
div
  el-table(:data='requests', v-loading='requests == null')
    el-table-column(label='Event')
      template(slot-scope='scope')
        div
          router-link(:to="'/user/requests/' + scope.row.id") {{scope.row.name}}
        div.secondary
          i.mat-icon person
          | {{scope.row.people}}
          span.hpad
            | {{$formatCents(scope.row.budget_cents)}}/person
          br
          | Request \#{{scope.row.id}}
    el-table-column(label='Delivery')
      template(slot-scope='scope')
        div
          i.mat-icon.secondary date_range
          |  {{$formatDate(scope.row.delivery_date)}}
        div
          i.mat-icon.secondary access_time
          |  {{ $formatTime(scope.row.delivery_time) }}

    el-table-column(label='Status')
      template(slot-scope='scope')
        status-tag(:status='scope.row.status')

    el-table-column(label='Actions')
      template(slot-scope='scope')
        ul.actions-list
          li(v-if='allowCancel(scope.row.status)')
            el-button(type='text', @click='markCancelledDialog(scope.row.id)')
              | Cancel
          li(v-if='allowCancel(scope.row.status)')
            el-button(type='text', @click='onEditDialog(scope.row.id)')
              | Edit

  el-pagination( 
    v-if="pagination.pages > 1"
    @current-change="onPaginationChange"
    :page-size="pagination.per_page", 
    :pager-count="pagination.pages", 
    layout="prev, pager, next", 
    :total="pagination.total")   
</template>

<script>

  import StatusTag from '../../common/StatusTag.vue'

  function data(){
    return {
      requests: null,
      pagination: {
        per_page: null,
        current: null,
        pages: null,
        total: null,
      }
    }
  }

  function created(){
    this.$bus.$on('request-created', this.getData)
    this.getData()
  }

  function onPaginationChange(current_page){
    this.getData(current_page);
  }

  function allowCancel(status){
    return (status != "CANCELLED"
      && status != "ESTIMATE_ORDERED"
      && status != "CLOSED")
  }

  function onEditDialog(id) {
    const target = `requests/${id}/edit`;
    this.$router.push(target)
  }

  function getData(current_page){
    let reqParams = (current_page ?{params:{ page:current_page}}:{params:{}});
    if(this.sorting){
      this.$isNumber(this.sorting)?reqParams.params.id=this.sorting:reqParams.params.q=this.sorting
    }
    this.$simplecater.get(this.targetUri,reqParams).then((r)=>{
      this.requests = r.data.data;
      this.pagination = r.data.pagination;
    }).catch(()=>{
      this.$message.error('Failed to load data')
    })
  }

  function markCancelledDialog ( id ) {
    const title = "Cancel request"
    const msg = "The request will be cancelled. Continue?"
    this.$confirm(msg, title, {
      confirmButtonText: 'Yes, cancel request',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(() => {
      this.markCancelled(id)
    }).catch(() => { })
  }

  function markCancelled ( id ) {
    const target = `/requests/${id}/mark_cancelled`
    this.$simplecater.post(target).then(r => {
      this.$message("The request has been cancelled")
      this.getData()
    }).catch(()=>{
      this.$message.error("Cancelling failed")
    })
  }

  const computed = {
    targetUri: function(){
      if(this.filter == 'all'){
        return '/requests'
      }else{
        return `/requests/${this.filter}`
      }
    }
  }

  const watch = {
    sorting: function(){
      this.getData();
    },
    filter: function(newFilter){
      console.log("FILTER FROM TO", this.filter, newFilter)
    }
  }

  const components = {
    StatusTag
  }

  const methods = {
    getData, onPaginationChange, markCancelledDialog, markCancelled, allowCancel, onEditDialog
  }

  const props = {
    filter: { required: true },
    sorting:{ required: false }
  }

  export default { methods, components, data, created, watch, props, computed }
</script>



// WEBPACK FOOTER //
// src/user/blocks/RequestList.vue